export const WINE_OFFER_2ND_GROUP_NAME = 'Add more & save';
export const WMX_PROMOTION_TYPE_CODE = 'WMX' as const;
